import { Button, Col, Row, Select } from '@rematter/ui-web';
import { LucideRotateCcw } from 'lucide-react';

import { FileTemplateType } from '../../../_graphql/queryFileTemplates';
import { TEMPLATE_TYPE_OPTIONS } from '../../../_state/locationDocumentTemplate.state';

export type TemplateSelectorProps = {
  selectedType: FileTemplateType;
  selectedTemplateId: string | undefined;
  templateOptions: { key: string; label: string }[];
  isLoadingTemplates: boolean;
  hasUnsavedChanges: boolean;
  isSaving: boolean;
  onTemplateChange: (templateId: string | undefined) => void;
  onSave: () => void;
  onReset: () => void;
};

export const TemplateSelector = ({
  selectedType,
  selectedTemplateId,
  templateOptions,
  isLoadingTemplates,
  hasUnsavedChanges,
  isSaving,
  onTemplateChange,
  onSave,
  onReset,
}: TemplateSelectorProps) => {
  const typeLabel =
    TEMPLATE_TYPE_OPTIONS.find((t) => t.key === selectedType)?.label ??
    selectedType;

  return (
    <Col className="@TemplateSelector gap-2 border-b border-neutral/10 bg-current/5 px-4 pt-3 pb-4">
      <div className="text-sm text-neutral/60">{typeLabel}</div>
      <Row className="items-center gap-3">
        <div className={'w-full'}>
          <Select
            className="w-full"
            value={selectedTemplateId}
            onChange={onTemplateChange}
            options={templateOptions}
            placeholder="Select a template..."
            isLoading={isLoadingTemplates}
            withEmptyOption
            emptyOptionLabel="No template"
          />
        </div>
        <Button
          variant="solid"
          color="primary"
          onClick={onSave}
          isDisabled={!hasUnsavedChanges || isSaving}
          isLoading={isSaving}
        >
          Use this template
        </Button>
        <Button
          variant="outline"
          color="neutral"
          onClick={onReset}
          isDisabled={!hasUnsavedChanges}
          icon={<LucideRotateCcw size={18} />}
        />
      </Row>
    </Col>
  );
};
